import { render, staticRenderFns } from "./ReferenceBasicData.vue?vue&type=template&id=0842c9ba&"
import script from "./ReferenceBasicData.vue?vue&type=script&lang=ts&"
export * from "./ReferenceBasicData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports